/** Submit, cancel, and delete actions for TaskForm. */
import { Box, Button } from '@mui/material';
import { useT } from '@/i18n/useT';

export function TaskFormActions({
  isBattlefield,
  pinToViewport = false,
  showDelete,
  isDeleting,
  onDelete,
  onCancel,
  showSubmit,
  isSubmitting,
  isEdit,
}) {
  const t = useT();

  return (
    <Box
      data-testid="task-form-actions"
      data-pinned-viewport={pinToViewport ? 'true' : undefined}
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 1.5,
        pt: 2,
        mt: pinToViewport ? 0 : 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        ...(pinToViewport
          ? {
              flexShrink: 0,
              bgcolor: 'background.paper',
              pb: 'calc(8px + env(safe-area-inset-bottom, 0px))',
              boxShadow: (theme) =>
                `0 -4px 12px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.35)' : 'rgba(0,0,0,0.06)'}`,
            }
          : {}),
      }}
    >
      {isBattlefield && showDelete ? (
        <Button
          type="button"
          color="error"
          onClick={onDelete}
          disabled={isDeleting}
        >
          {t('taskform.deleteTask', 'Taak verwijderen')}
        </Button>
      ) : null}
      <Button type="button" color="inherit" onClick={onCancel}>
        {t('taskform.cancel', 'Annuleren')}
      </Button>
      {showSubmit ? (
        <Button
          type="submit"
          variant="contained"
          color="secondary"
          disabled={isSubmitting}
        >
          {isEdit
            ? t('taskform.saveChanges', 'Wijzigingen opslaan')
            : t('taskform.addTask', 'Taak opslaan')}
        </Button>
      ) : null}
    </Box>
  );
}
